import axios from "axios";

export const backendUrl = "https://stars-metin2.com";
// export const backendUrl = "http://localhost:8000";

const axiosInstance = axios.create({
  baseURL: backendUrl,
  // baseURL: "https://rayah-eg.com",
});

axiosInstance.interceptors.request.use(config => {
  return config;
});

export default axiosInstance;